/**
 * The endpoint the occupants feature talks to: the portal's own
 * `contract-contacts` resource, a plain `apiResource` — index, store, update
 * and destroy. There is no atomic-operations route here, so a write that spans
 * several rows is several requests.
 */
export const CONTRACT_CONTACTS_ENDPOINT = "/folloportal/contract-contacts";

/** The person behind the subscriptions — `POST` to create one (attached to the
 * logged-in customer's client), `PATCH /{id}` to edit one. `contract-contacts`
 * only ever attaches a contact that already exists (`contact_id` is required
 * and checked against the contract), so writing the person is its own request. */
export const CONTACTS_ENDPOINT = "/folloportal/contacts";

export const CONTACTS_RESOURCE_TYPE = "contacts";

export const RESOURCE_TYPE = "contract-contacts";

/** A contact has a row per (destination, alert type), and the endpoint
 * paginates rows rather than contacts — so a contact's rows would straddle a
 * page boundary. One contract's subscriptions are fetched whole and grouped
 * client-side instead. */
export const CONTRACT_CONTACTS_PER_PAGE = 100;
